import { render, staticRenderFns } from "./UserAvatarBadge.vue?vue&type=template&id=2ae44504&scoped=true&"
import script from "./UserAvatarBadge.vue?vue&type=script&lang=js&"
export * from "./UserAvatarBadge.vue?vue&type=script&lang=js&"
import style0 from "./UserAvatarBadge.vue?vue&type=style&index=0&id=2ae44504&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae44504",
  null
  
)

export default component.exports